// @flow

import React from 'react';

type Props = {
  isPassed: boolean,
}

function CrossSellGaugeElement({ isPassed }: Props) {
  return (
    <div className={`cross-sell-gauge-element${isPassed ? ' cross-sell-gauge-element--activated' : ''}`}>
      <i className="fa fa-male" />
    </div>
  );
}

export default CrossSellGaugeElement;

